import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import img from '../../img/404.gif';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 25,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    height: 320,
  }
}));

const E404Page = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <Typography variant="h1">
              404: La página que estás buscando no está acá
            </Typography>
            <Typography variant="subtitle2">
              Para volver al inicio hacé click <Link to="/">acá</Link>
            </Typography>
            <img
              alt="Not found"
              className={classes.image}
              src={img}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default E404Page;